// extracted by mini-css-extract-plugin
export default {"chipContainer":"vRFoahGX","value":"gSV5vxVy","text":"KVWomC5j"};